import qs from 'qs'

export const toEsusParameters = (parameters?: any) => {
  return btoa(qs.stringify(parameters))
}
